// @Core
import { sessionUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { REFRESH_PROPS } from './constants/auth-watcher-footer.handlers.constants';
// Enums
import { AuthScenariosEnumeration } from 'providers/auth-watcher/enumerations/auth-scenarios.enumeration';
// Types
import {
  AuthWatcherFooterHandlersBuilderType,
  AuthWatcherFooterHandlersReturnType,
} from './types/auth-watcher-footer.handlers.type';
// Utilities
import { navigateToCallbackUrl } from 'utils/app-callback-url.utils';

const doTryRefreshTokenOrRedirectToAmazon = async ({
  setAuthConflict,
  setFetching,
  ...props
}: Omit<AuthWatcherFooterHandlersBuilderType, 'authConflict' | 'setError'>): Promise<void> => {
  setFetching(true);

  const refreshed = await sessionUtils.refreshToken(REFRESH_PROPS);

  if (refreshed) {
    setAuthConflict(null);
    setFetching(false);
  } else {
    // Declinar tambien?
    navigateToCallbackUrl(props);
  }
};

const redirectToCallbackUrl = ({
  setFetching,
  ...props
}: Pick<AuthWatcherFooterHandlersBuilderType, 'setFetching' | 'callbackUrl' | 'loanId'>): void => {
  setFetching(true);
  navigateToCallbackUrl(props);
};

const authWatcherModalMainButtonClickHandler = ({
  authConflict,
  callbackUrl,
  loanId,
  setFetching,
  setError,
  ...restProps
}: AuthWatcherFooterHandlersBuilderType): void | Promise<void> =>
  ({
    [AuthScenariosEnumeration.ACCESS]: () =>
      doTryRefreshTokenOrRedirectToAmazon({ callbackUrl, loanId, setFetching, ...restProps }),
    [AuthScenariosEnumeration.REFRESH]: () =>
      redirectToCallbackUrl({ callbackUrl, loanId, setFetching }),
  }[authConflict as AuthScenariosEnumeration]());

const AuthWatcherFooterHandlers = (
  props: AuthWatcherFooterHandlersBuilderType
): AuthWatcherFooterHandlersReturnType => ({
  handleAuthWatcherModalMainButtonClick: () => authWatcherModalMainButtonClickHandler(props),
});

export { AuthWatcherFooterHandlers };
